jQuery(function ($) {
    /*
    * Autohide toolnav
    -----------------------------------------------------*/
    function autohideToolnav() {

        var elSelector = '.tool-nav',
            $element = $(elSelector);

        if (!$element.length) return true;

        var elHeight = 0,
            $document = $(document),
            dHeight = 0,
            $window = $(window),
            wHeight = 0,
            wScrollCurrent = 0,
            wScrollBefore = 0,
            wScrollDiff = 0;

        $window.on('scroll', function () {
            if (!window.matchMedia('(min-width: 1200px)').matches) {
                elHeight = $element.outerHeight();
                dHeight = $document.height();
                wHeight = $window.height();
                wScrollCurrent = $window.scrollTop();
                wScrollDiff = wScrollBefore - wScrollCurrent;

                if (wScrollCurrent <= 0) // scrolled to the very bottom; element sticks to the bottom
                    $element.removeClass("slideout");

                else if (wScrollDiff > 0) // scrolled up; element slides in
                    $element.removeClass("slideout");

                else if (wScrollDiff < 0) // scrolled down
                {
                    if (wScrollCurrent + wHeight >= dHeight - elHeight) // scrolled to the very bottom; element slides in
                        $element.removeClass("slideout");

                    else // scrolled down; element slides out
                        $element.addClass("slideout");
                    // remove all active classes
                    // $(".toolnav .active").removeClass("active");
                }

                wScrollBefore = wScrollCurrent;
            }
        });

    }
    autohideToolnav();
});
